import {
  configureStore, type ThunkAction, type Action,
} from '@reduxjs/toolkit';

import clientReducer from 'store/client-details/clientSlice';
import clientsReducer from 'store/clients/clientsSlice';
import newsReducer from 'store/news/newsSlice';
import userReducer from 'store/user/userSlice';
import usersReducer from 'store/users/usersSlice';

export const store = configureStore({
  reducer: {
    loggedUser: userReducer,
    clients: clientsReducer,
    clientDetails: clientReducer,
    users: usersReducer,
    news: newsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action
>;
